import classNames from 'classnames'
import type { FC } from 'react'
import React, { useCallback, useRef, useState } from 'react'

import { useTableContext } from './table-context'
import type { TableHeadCellProps } from './types'
import { BoxPrivate } from '../_primitives/box/box'

const defaultStyles = {
  borderBottom: 'lightGray',
  verticalAlign: 'middle',
  fontWeight: 'bold'
}

export const TableHeadCell: FC<TableHeadCellProps> = ({
  variant = 'headCell',
  className,
  title,
  children,
  ...rest
}) => {
  const { variant: tableVariant } = useTableContext()
  const localRef = useRef<HTMLElement>(null)
  // Define state and function to update the value
  const [showTitle, setShowTitle] = useState(false)

  const handleOnMouseOver = useCallback(() => {
    const compare =
      !!localRef.current &&
      localRef.current.scrollWidth > localRef.current.clientWidth
    setShowTitle(compare)
  }, [localRef])

  return (
    <BoxPrivate
      ref={localRef}
      __themeKey="tables"
      variant={tableVariant ? `${tableVariant}.headCell` : variant}
      as="th"
      className={classNames('csg-tui-th', className)}
      onMouseOver={handleOnMouseOver}
      title={showTitle ? title ?? '' : ''}
      __css={defaultStyles}
      {...rest}
    >
      {children}
    </BoxPrivate>
  )
}

export default TableHeadCell
